"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const generateCloudFunctionCall = (functions, functionName) => async (params) => {
    const { data } = await functions.httpsCallable(functionName)(params);
    return data;
};
exports.default = generateCloudFunctionCall;
